import type { OneTimeSignInErrorCode } from './oneTimeSignIn'

const en = {
    title: 'Sign in with a link',
    description: 'Access your storage without entering a password.',
    pending: 'Signing you in…',
    pendingHint: 'Verifying the link and your session.',
    back: 'Go to sign in',
    errorTitle: 'Could not sign in',
    newLink:
        'Open a new sign-in link from the application, or sign in with your login and password.',
    errors: {
        invalidLink: 'This sign-in link is invalid.',
        expired: 'This link has expired or has already been used.',
        rateLimited: 'Too many sign-in attempts. Please try again later.',
        unavailable: 'The sign-in service is currently unavailable.',
        invalidSession: 'Could not verify your session after signing in.',
        network:
            'Could not connect. Check your connection and open a new link.',
        timeout: 'Sign-in took too long. Please open a new link.',
    } satisfies Record<OneTimeSignInErrorCode, string>,
}
const ru: Omit<Record<keyof typeof en, string>, 'errors'> & {
    errors: Record<OneTimeSignInErrorCode, string>
} = {
    title: 'Вход по ссылке',
    description: 'Доступ к вашим хранилищам без ввода пароля.',
    pending: 'Входим…',
    pendingHint: 'Проверяем ссылку и вашу сессию.',
    back: 'Перейти ко входу',
    errorTitle: 'Не удалось войти',
    newLink:
        'Откройте новую ссылку для входа из приложения или войдите с логином и паролем.',
    errors: {
        invalidLink: 'Эта ссылка для входа некорректна.',
        expired: 'Срок действия ссылки истёк или она уже использована.',
        rateLimited: 'Слишком много попыток входа. Повторите позже.',
        unavailable: 'Сервис входа сейчас недоступен.',
        invalidSession: 'Не удалось подтвердить сессию после входа.',
        network:
            'Не удалось подключиться. Проверьте соединение и откройте новую ссылку.',
        timeout: 'Вход занял слишком много времени. Откройте новую ссылку.',
    },
}
export const oneTimeMessages = { en, ru }
